<ng-container *transloco="let t">
  @if (dataConsumptionState$ | async; as dataConsumptionState) {
    @if (activeClientDataConsumption$ | async; as clientDataConsumption) {
      @let percentUsed = Math.max((clientDataConsumption.used * 100) / clientDataConsumption.total, 1);
      @if (detailedMode) {
        <div class="my-2 flex flex-col gap-4">
          <div class="my-2 flex flex-col items-start gap-5 lg:flex-row">
            <tui-icon class="text-2xl!" data-testid="icon" [icon]="dataConsumptionState.icon" />
            <div class="flex flex-col gap-2">
              <h5 data-testid="title" tuiTitle="m">
                {{
                  dataConsumptionState.title(
                    clientDataConsumption.total - clientDataConsumption.used | formatGoDataUnit
                  )
                }}
              </h5>
              <div
                class="flex h-6 w-full overflow-hidden rounded-full"
                data-testid="progress"
                [ngClass]="dataConsumptionState.styles.containerClass">
                <div
                  [ngClass]="dataConsumptionState.styles.progressClass"
                  [ngStyle]="{ width: percentUsed + '%' }"></div>
              </div>
              <p
                class="text-sm"
                [ngClass]="
                  dataConsumptionState.styles.hintAppearance === 'negative'
                    ? 'text-text-error-primary'
                    : 'text-text-tertiary'
                ">
                <ng-container [ngTemplateOutlet]="dataConsumptionTemplate" />
              </p>
              <p data-testid="description">
                {{ t('Vous disposez de') }}
                <span class="font-bold">{{ clientDataConsumption.total | formatGoDataUnit }}</span>
                {{ t('de stockage dans votre espace sécurisé Pixacare.') }}
              </p>
              <p>{{ t("Contactez nous pour bénéficier davantage d'espace de stockage.") }}</p>
            </div>
          </div>
          <button appearance="primary" data-testid="contact" tuiButton type="button" (click)="contact()">
            {{ t("Demander de l'aide") }}
          </button>
        </div>
      } @else {
        <div
          class="relative h-10 w-full cursor-pointer overflow-hidden rounded-full ring-border-normal/50 transition-all hover:ring-3"
          data-testid="button"
          tuiHintDirection="end"
          [ngClass]="dataConsumptionState.styles.containerClass"
          [tuiHint]="dataConsumptionTemplate"
          [tuiHintAppearance]="dataConsumptionState.styles.hintAppearance"
          (click)="manageStorage()">
          <div
            class="absolute z-10 flex h-full w-full items-center gap-4 py-2 text-sm"
            [ngClass]="{
              'pl-2 pr-4': !collapsed,
              'px-2': collapsed,
            }">
            <tui-icon [icon]="dataConsumptionState.icon" />
            <span animateDirection="left" class="flex-1 truncate" [animateFade]="!collapsed">
              {{ dataConsumptionState.label }}
            </span>
            <span
              animateDirection="left"
              class="truncate font-bold"
              data-testid="consumption-detail"
              [animateFade]="!collapsed">
              {{ percentUsed | number: '1.0-0' }} %
            </span>
          </div>
          <div
            class="absolute z-0 h-full rounded-full"
            data-testid="progress"
            [ngClass]="dataConsumptionState.styles.progressClass"
            [ngStyle]="{ width: percentUsed + '%' }"></div>
        </div>
      }

      <ng-template #dataConsumptionTemplate>
        {{ t("{{ used }} consommés sur {{ total }}", { used: clientDataConsumption.used | formatGoDataUnit, total:
        clientDataConsumption.total | formatGoDataUnit, }) }}
      </ng-template>
    }
  }
</ng-container>
